<template>
  <HScaffold title="SearchGame">
    <div class="tSearchGameParentDiv">
      SearchGame

    </div>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";

  const user = useUserStore();
  const http = useHHttp();

</script>


<style scoped>

  .tSearchGameParentDiv {
    display: flex;
    flex-direction: column;
    padding: 10px 10px 20px 10px;
  }

</style>
